let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9n8Rc")).then(() => parcelRequire('kc1MS'));